// // Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box, Typography } from '@mui/material'
import { AddressPill } from '@react/components/addresses/AddressPill'
import ViewLogo from '@react/components/elements/ViewLogo'
import { toCompanyAddrString } from '@react/fetchers/companyProfileFetchers'
import { OtStoreState, useOtSelector } from '@react/redux/store'
import { EthAddr } from '@shared/SchemaTypes'
import React from 'react'

export const CompanyProfileAddressItem: React.FC<{ walletAddr: EthAddr; hasBorder?: boolean }> = ({
  walletAddr,
  hasBorder,
}): React.ReactElement => {
  const companyProfiles = useOtSelector((state: OtStoreState) => state.poolState.companyProfiles)

  const { companyProfile } = toCompanyAddrString(walletAddr, companyProfiles)
  if (companyProfile) {
    return (
      <Box
        sx={{
          width: '100%',
          borderWidth: hasBorder ? 1 : 0,
          borderColor: 'grey.500',
          borderStyle: 'solid',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <ViewLogo size={30} skipBlank={true} addrOrId={companyProfile.uuid} />
        <Box
          sx={{
            width: '100%',
            borderWidth: hasBorder ? 1 : 0,
            borderColor: 'grey.500',
            borderStyle: 'solid',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Typography sx={{ marginLeft: 2 }} variant="bodyBold">
            {companyProfile.companyName}
          </Typography>
          <Typography sx={{ marginLeft: 2 }} variant="caption">
            <AddressPill addr={walletAddr} />
          </Typography>
        </Box>
      </Box>
    )
  } else {
    return (
      <Box
        sx={{
          width: '100%',
          borderWidth: hasBorder ? 1 : 0,
          borderColor: 'grey.500',
          borderStyle: 'solid',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Typography sx={{ marginLeft: 2 }} variant="bodyBold">
          <AddressPill addr={walletAddr} />
        </Typography>
      </Box>
    )
  }
}
